import { render, staticRenderFns } from "./ArchiveShare.vue?vue&type=template&id=29b1a010&scoped=true"
import script from "./ArchiveShare.vue?vue&type=script&lang=js"
export * from "./ArchiveShare.vue?vue&type=script&lang=js"
import style0 from "./ArchiveShare.vue?vue&type=style&index=0&id=29b1a010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b1a010",
  null
  
)

export default component.exports